export default __webpack_public_path__ + "static/media/top-b-9.bbf5b259.jpg";